import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Slide, { SlideProps } from "@mui/material/Slide";
import clsx from "clsx";
import { styled } from "@mui/material";
import Alert, { AlertColor } from "@mui/material/Alert";

//region [[ Styles ]]
const ToastContainer = styled(Snackbar)({
  "&.absolute": {
    position: "absolute",
  },
  "& .MuiSnackbarContent-root": {
    alignSelf: "end", //hack to make the toast appear at the bottom
  },
});
//endregion [[ Styles ]]
//region [[ Props ]]
interface ToastProps {
  text: string | React.ReactNode;
  open: boolean;
  duration?: number;
  onClose: () => void;
  severity?: AlertColor;
  position?: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

const Toast = ({
  text,
  open,
  onClose,
  duration,
  severity,
  position,
}: ToastProps) => {
  return (
    <ToastContainer
      className={clsx("kahun-toast", position ? position : "")}
      open={open}
      autoHideDuration={duration || 5000}
      TransitionComponent={SlideTransition}
      onClose={onClose}
      message={text}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClick={onClose}
    >
      {severity && (
        <Alert severity={severity} variant="filled">
          {text}
        </Alert>
      )}
    </ToastContainer>
  );
};

export default Toast;
